import ListSearchBar from "../../ListSearchBar";
import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { InputGroup, ListGroup } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { useTranslate } from "../../../hooks/LanguageProvider";
import { searchItems } from "../../../config/search/search.data";
import { SearchItem } from "../../../config/search/search.types";

const normalize = (s: string) =>
  s.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

type SearchItemResolved = {
  id: number;
  title: string;
  content: string;
  route: string;
};

const NavbarSearch: React.FC = () => {
  const { translate } = useTranslate();

  const [searchTerm, setSearchTerm] = useState("");
  const [isSearchVisible, setSearchVisible] = useState(false);

  // 1) Items traduits (dépend de la langue)
  const resolvedItems: SearchItemResolved[] = useMemo(() => {
    return (searchItems as SearchItem[]).map((it) => ({
      id: it.id,
      route: it.route,
      title: translate(it.title),
      content: translate(it.content),
    }));
  }, [translate]);

  // 2) Filtrage (pas besoin de useState filteredPages)
  const filteredItems = useMemo(() => {
    const term = normalize(searchTerm.trim());
    if (!term) return [];
    return resolvedItems.filter(
      (item) =>
        normalize(item.title).includes(term) ||
        normalize(item.content).includes(term)
    );
  }, [searchTerm, resolvedItems]);

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const val = event.target.value;
    setSearchTerm(val);
    setSearchVisible(true);
  };

  const handleItemClick = () => {
    setSearchVisible(false);
    setSearchTerm("");
  };

  return (
    <div className="search-container hide-on-mobile" style={{ position: "relative" }}>
      <ListSearchBar onReset={()=>{setSearchTerm("");setSearchVisible(false);}} resetLabel={translate("Reset search")}><Form.Control
          type="text"
          value={searchTerm}
          onChange={handleSearch}
          onFocus={() => setSearchVisible(true)}
          placeholder={translate("Search here") + "..."}
        /></ListSearchBar>

      {isSearchVisible && searchTerm && filteredItems.length > 0 && (
        <ListGroup
          className="results-container"
          style={{
            position: "absolute",
            top: "100%",
            left: 0,
            maxHeight: "400px",
            border: "1px solid #ddd",
            borderRadius: "4px",
            backgroundColor: "#fff",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            zIndex: 10,
            overflowY: "auto",
          }}
        >
          {filteredItems.slice(0, 20).map((item) => (
            <ListGroup.Item key={item.id} className="result-item" onClick={handleItemClick}>
              <strong>
                <Link to={item.route}>{item.title}</Link>
              </strong>
              : {item.content}
            </ListGroup.Item>
          ))}
        </ListGroup>
      )}
    </div>
  );
};

export default NavbarSearch;
